import {
  boxApply1qmzdb3dh90hg as boxApply,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  decodeSerializableElement$default2o0k93vobxyld as decodeSerializableElement$default,
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  decodeSequentially27kmi8jnnsnbc as decodeSequentially,
  decodeCollectionSize3l4gjp9ef5h8u as decodeCollectionSize,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
} from './Decoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractDecoderClass;
function AbstractDecoder() {
  if (AbstractDecoderClass === VOID) {
    class $ {
      constructor($box) {
        boxApply(this, $box);
      }
      w12() {
        throw SerializationException().p10(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
      }
      x12() {
        return true;
      }
      y12() {
        return null;
      }
      z12() {
        var tmp = this.w12();
        return typeof tmp === 'boolean' ? tmp : THROW_CCE();
      }
      a13() {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      b13() {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      c13() {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      d13() {
        var tmp = this.w12();
        return typeof tmp === 'bigint' ? tmp : THROW_CCE();
      }
      e13() {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      f13() {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      g13() {
        var tmp = this.w12();
        return tmp instanceof Char() ? tmp.z2_1 : THROW_CCE();
      }
      h13() {
        var tmp = this.w12();
        return typeof tmp === 'string' ? tmp : THROW_CCE();
      }
      i13(enumDescriptor) {
        var tmp = this.w12();
        return typeof tmp === 'number' ? tmp : THROW_CCE();
      }
      j13(descriptor) {
        return this;
      }
      k13(deserializer, previousValue) {
        return this.qz(deserializer);
      }
      l13(descriptor) {
        return this;
      }
      m13(descriptor) {
      }
      n13(descriptor, index) {
        return this.z12();
      }
      o13(descriptor, index) {
        return this.a13();
      }
      p13(descriptor, index) {
        return this.b13();
      }
      q13(descriptor, index) {
        return this.c13();
      }
      r13(descriptor, index) {
        return this.d13();
      }
      s13(descriptor, index) {
        return this.e13();
      }
      t13(descriptor, index) {
        return this.f13();
      }
      u13(descriptor, index) {
        return this.g13();
      }
      v13(descriptor, index) {
        return this.h13();
      }
      w13(descriptor, index) {
        return this.j13(descriptor.y11(index));
      }
      x13(descriptor, index, deserializer, previousValue) {
        return this.k13(deserializer, previousValue);
      }
      z13(descriptor, index, deserializer, previousValue) {
        // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
        var isNullabilitySupported = deserializer.az().l11();
        var tmp;
        if (isNullabilitySupported || this.x12()) {
          tmp = this.k13(deserializer, previousValue);
        } else {
          tmp = this.y12();
        }
        return tmp;
      }
    }
    protoOf($).y13 = decodeSerializableElement$default;
    protoOf($).qz = decodeSerializableValue;
    protoOf($).a14 = decodeSequentially;
    protoOf($).c14 = decodeCollectionSize;
    initMetadataForClass($, 'AbstractDecoder', VOID, VOID, [Decoder(), CompositeDecoder()]);
    AbstractDecoderClass = $;
  }
  return AbstractDecoderClass;
}
//region block: exports
export {
  AbstractDecoder as AbstractDecoder35guh02ubh2hm,
};
//endregion

//# sourceMappingURL=AbstractDecoder.mjs.map
